import { routes } from "@/common/utils/routes";
import { UserListWidgetAlive } from "components/widgets/UserListWidgetAlive";
import { useTrendingUsers } from "@/common/hooks/useTrendingUsers";
import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";
import { FeedModuleTypeEnum } from "@/common/services/types";

interface ITrendingCreatorsModuleProps {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const TrendingCreatorsModule = ({
  moduleId,
  moduleType,
}: ITrendingCreatorsModuleProps) => {
  const { creators, isLoading } = useTrendingUsers();

  if (isLoading || !creators.length) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <UserListWidgetAlive
        className="trendingCreators"
        title="Trending Creators"
        link={routes.creators()}
        items={[...creators]}
      />
    </FeedModuleContainer>
  );
};
